import { MessagingBridgeManagerMasterContextProvider } from "../../../contexts/messagingBridgeManagerProvider";
import { useSettings } from "../../../hooks/settings";
import RouteContainer, { RouteContainerProps } from "./RouteContainer";

export interface MasterRouteContainerProps extends RouteContainerProps {
  mode: "expert" | "student" | "pedagogy" | "public";
}

export const MasterRouteContainer = ({ element, children, mode }: MasterRouteContainerProps) => {
  const [settings] = useSettings();

  if (mode === "expert") {
    return (
      <MessagingBridgeManagerMasterContextProvider
        options={{
          enableBroadcast: settings.bridge?.master?.enableBroadcast ?? false,
          password: settings.secret?.localPassword ?? undefined,
        }}
      >
        <RouteContainer element={element} children={children} />
      </MessagingBridgeManagerMasterContextProvider>
    );
  }
  return <RouteContainer element={element} children={children} />;
};

export default MasterRouteContainer;
